export default class CurrencyUtils {
  static formatCurrency = (value) => {
    return `${value < 0 ? '(' : ''}$${Math.abs(value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${value < 0 ? ')' : ''}`;
  }
}